var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-sex"},[_c('div',{staticClass:"title"},[_vm._v("成长值：")]),_c('div',{staticClass:"tip"},[_vm._v("客户当前成长值。你可以结合会员级别条件标签，给已达到成长值门槛却还没有激活会员身份的客户推送内容或打标签")]),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"flex"},[_c('num-mod',{ref:"numMod",attrs:{"disabled":_vm.disabled,"txt":"个","precision":0}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }